export default "__VITE_ASSET__62aa416f__"